module.exports = __webpack_public_path__ + "img/96.c2f73c7e.jpg";